export const closeHandler = (entry, logger) => {
  return (entry && entry.clear) || (
    () => {
      logger && logger.error('Expected a clear function for ', entry);
    }
  );
};

export const getMessageStatus = function(messageType="") {
  switch(messageType) {
    case "applicationInfo":
      return "info";
    case "applicationSuccess":
      return "success";
    case "applicationError":
      return "error";
    case "applicationWarning":
        return "warning";
    default:
      return "";
  }
};